import { CALL_API, REQUEST_GET, REQUEST_POST } from '../middleware/api'
import { WORKSPACE, WORKSPACE_COLLECTION } from '../schemas/index'

export const WORKSPACES_REQUEST = 'WORKSPACES_REQUEST'
export const WORKSPACES_SUCCESS = 'WORKSPACES_SUCCESS'
export const WORKSPACES_FAILURE = 'WORKSPACES_FAILURE'
export const WORKSPACE_CREATE_REQUEST = 'WORKSPACE_CREATE_REQUEST'
export const WORKSPACE_CREATE_SUCCESS = 'WORKSPACE_CREATE_SUCCESS'
export const WORKSPACE_CREATE_FAILURE = 'WORKSPACE_CREATE_FAILURE'

export function createWorkspace(company, attrs) {
  return {
    [CALL_API]: {
      types: [
        WORKSPACE_CREATE_REQUEST,
        WORKSPACE_CREATE_SUCCESS,
        WORKSPACE_CREATE_FAILURE
      ],
      endpoint: `companies/${company.id}/workspaces.json`,
      requestType: REQUEST_POST,
      schema: WORKSPACE,
      data: {
        workspace: attrs
      }
    }
  }
}

function fetchWorkspaces(company) {
  return {
    [CALL_API]: {
      types: [WORKSPACES_REQUEST, WORKSPACES_SUCCESS, WORKSPACES_FAILURE],
      endpoint: `companies/${company.id}/workspaces.json`,
      requestType: REQUEST_GET,
      schema: WORKSPACE_COLLECTION
    }
  }
}

function shouldFetchWorkspaces(state) {
  const { workspaces } = state

  if (workspaces.isFetching) {
    return false
  } else if (workspaces.items.length === 0) {
    return true
  } else {
    return false
  }
}

export function fetchWorkspacesIfNeeded(company) {
  return (dispatch, getState) => {
    if (shouldFetchWorkspaces(getState())) {
      return dispatch(fetchWorkspaces(company))
    } else {
      Promise.resolve()
    }
  }
}



// WEBPACK FOOTER //
// ../src/actions/workspaceActions.js